import { DataService } from './../services/data.service';
import { PageContent } from './../models/models';
import { Component, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';
declare var $: any;

@Component({
  selector: 'admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {
  loading: boolean = true;
  pageContent: PageContent = new PageContent();

  constructor(private dataService: DataService) { }

  ngOnInit(): void {
    this.getPageContent();
  }


  getPageContent(){
    this.dataService.getPC().snapshotChanges().pipe(
      map(changes =>
        changes.map(c =>
          ({ id: c.payload.doc.id, ...c.payload.doc.data() })
        )
      )
    ).subscribe(data => {
      this.pageContent = data[0];
      this.loading = false;

      setTimeout(()=>{
        $("#sidebar").css("background-color", this.pageContent.base_color);
        console.log(this.pageContent.base_color)
       }, 500);
      // console.log(this.pageContent)
    });
  }

}
